import { render } from "./Modalgetbootstrap.vue?vue&type=template&id=5e2847c4"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__